import { AppStoreProvider } from 'enums/appStoreProviders';
import { ResourceType } from 'enums/videoType';
import { PaymentProvider } from 'enums/paymentProviders';
import { ObjectPermissionSetData } from 'types/permissions';

export enum UrlBuilderTypes {
 SET_BUILDER_DATA = 'SET_BUILDER_DATA',
 SET_BUILDER_PUBLISH = 'SET_BUILDER_PUBLISH',
 SET_BUILDER_PERMISSIONS = 'SET_BUILDER_PERMISSIONS',
 UPDATE_BUILDER_PERMISSIONS = 'UPDATE_BUILDER_PERMISSIONS',
}

export interface Info {
 phoneNumber: string;
 email: string;
 calendar: string;
 location: string;
 website: string;
 links: InfoLinks[];
}

export interface InfoLinks {
 title: string;
 url: string;
}

export interface AboutMe {
 text: string;
}

export interface SocialNetworks {
 networkName: string;
 url: string;
}

export interface UploadType {
 _id: string;
 fileName: string;
 filePath: string;
 mimeType: string;
 createdAt?: string;
 updatedAt: string;
 __v?: number;
 actionType?: ResourceType;
 fileUrl?: string;
}

export interface Testimonial {
 rating: number;
 comment: string;
 userPhoto: UploadType | null;
 fullName: string;
 title: string;
}

export interface CustomCTA {
 buttonText: string;
 buttonLink: string;
 buttonColor?:string;
}

export interface AppStores {
 storeName: AppStoreProvider | '';
 storeLink: string;
}

export interface ContactFormField {
 fieldName: string;
 fieldType: string;
 isRequired: boolean;
 editable: boolean;
}
export interface ContactForm {
 contactMail: string;
 fields: ContactFormField[];
}

export interface Video {
 actionType: ResourceType | null;
 file?: any;
 videoUrl?: string;
}

export interface PaymentOption {
 name: PaymentProvider;
 url: string;
}

export interface Published {
    published: boolean;
    publishedDate?: Date;
}

export interface UrlBuilderState {
 _id: string;
 userId: string;
 cardId: number;
 info: Info;
 aboutMe: AboutMe;
 socialNetworks: SocialNetworks[];
 video: Video;
 images: UploadType[];
 testimonials: Testimonial[];
 customCTA: CustomCTA;
 appStores: AppStores[];
 contactForm: ContactForm;
 primaryColor: { color: string };
 published: Published;
 paymentOptions: PaymentOption[];
 urlDesignType: string;
 permissions: ObjectPermissionSetData[];
 order: string[];
}